import { render } from "./CogOutline.vue?vue&type=template&id=96fed70c"
import script from "./CogOutline.vue?vue&type=script&lang=js"
export * from "./CogOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__